export default {
    COOKIE_NAME:"ACTIVE365-DEVICE-TOKEN-"
}